import { useContext } from 'react'
import { GoogleAuthProvider } from 'firebase/auth'
import { Navigate, useNavigate } from 'react-router-dom'
import { TokenResponse, useGoogleLogin } from '@react-oauth/google'
import { LoginContext } from '../../contexts/login-context'
import { ModalContext } from '../../contexts/modal-context'
import { GlobalStyle } from '../../styles/global-styles'
import {
  LoginPageContainer,
  LoginPageImage,
  LoginFormTitle,
  LoginFormText,
  GoogleIcon,
  TopCircle,
  LeftCircle,
  BottomCircle,
  PageContent
} from './login-styles'
import ResultPopup from '../../components/modal/popup/result-popup/result-popup'
import homepageImg from './assets/homepage.svg'
import googleIcon from './assets/google-icon.png'
import Button from '../../components/atoms/Button/button'
import logAnalyticsEvent from '../../utilities/firebase-analytics'
import andlogo from '../login-page/assets/andlogo.png'
import Modal from '../../components/modal/modal'
import Banner from '../../components/atoms/Banner/banner'

const Login = () => {
  const { handleAuth, user } = useContext(LoginContext)
  const { setModalOpen, setModalContent } = useContext(ModalContext)
  const navigate = useNavigate()
  logAnalyticsEvent('page_view', {
    page_location: '/login',
    page_title: 'Login'
  })

  const openModal = (resultMessage: string) => {
    setModalOpen(true)
    setModalContent(
      <ResultPopup success={false} headerText="">
        <p>{resultMessage}</p>
      </ResultPopup>
    )
  }

  const onLoginResult = async (response: TokenResponse) => {
    const credential = GoogleAuthProvider.credential(null, response.access_token)

    try {
      await handleAuth(credential)
      navigate('/')
      logAnalyticsEvent('user_authenticated')
      setModalOpen(false)
    } catch (e) {
      if (e instanceof Error) {
        logAnalyticsEvent('user_authentication_error')
        const resultMessage =
          e.message === 'DOMAIN' ? 'Please sign in with and.digital domain' : 'Error signing in'
        openModal(resultMessage)
      }
    }
  }

  const onSignInWithGoogleClicked = useGoogleLogin({
    onSuccess: onLoginResult
  })

  if (user) return <Navigate to="/" />
  return (
    <>
      <GlobalStyle page="login" />
      <Banner />
      <Modal />
      <LoginPageContainer>
        <PageContent>
          <LoginPageImage src={homepageImg} alt="Homepage image" />
          <LoginFormTitle>
            Welcome to <img className="andlogo" src={andlogo} />
            Space
          </LoginFormTitle>
          <LoginFormText>Please book your free desk space in the office today.</LoginFormText>
          <Button
            maxContent
            altText="Google sign in"
            buttonIcon={<GoogleIcon src={googleIcon} alt="Google icon" />}
            buttonText="Sign in with Google"
            isPrimary={false}
            isCircle={false}
            onClick={() => {
              onSignInWithGoogleClicked()
              logAnalyticsEvent('google_signin_clicked')
            }}
          />
        </PageContent>
        <TopCircle />
        <LeftCircle />
        <BottomCircle />
      </LoginPageContainer>
    </>
  )
}

export default Login
